<template>
    <div class="w-100">
        <!-- media manager -->
        <media-manager
            v-if="showMediaManagerImage"
            :maxItemSelected="1"
            :maxUploadFiles="1"
            @receiveMedias="addPictures($event)"
            @closeTabs="() => showMediaManagerImage = false"
        />

        <!-- component -->
        <label class="font-14 mt-2" for="upload-input">
            Imagem
        </label>
        
        <div class="w-100 h-100 d-flex justify-content-start align-items-center">
            <div id="image-container" class="position-relative">
                <base-image
                    class="image-container--image"
                    :externalImage="externalImage"
                    :source="activeUrl" 
                />

                <div
                    v-b-tooltip.hover
                    title="Trocar Imagem"
                    @click.prevent="showManager"
                    :class="[url ? 'd-flex' : 'd-none']"
                    id="change-image"
                >
                    <button
                        class="btn btn-block btn-primario px-2 py-0"
                    >
                        <i class="fal fa-sync font-14" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MediaManager from '../organisms/MediaManager.vue'
import BaseImage from './BaseImage.vue'

export default {
    name: 'SettingFrameImage',
    data() {
        return {
            showMediaManagerImage: false,
            image: {
                url: null
            }
        }
    },
    props: {
        url: {
            type: String,
        },
        externalImage: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    components: {
        BaseImage,
        MediaManager
    },
    methods: {
        showManager() {
            this.showMediaManagerImage = true;
        },
        addPictures(picture) {
            this.image.url = picture[0].url
            this.showMediaManagerImage = false;

            this.$emit('onChangeImage', this.image.url);
        },
    },
    computed: {
        activeUrl() {
            if (this.image.url) { return this.image.url }
        }
    },
    created() {
        this.image.url = this.url
    }
}
</script>

<style scoped>
    .image-container--image {
        width: 200px;
        min-height: 200px;
        object-fit: cover;
        object-position: center;
        border: 2px dashed var(--main-color);
        border-radius: 8px;
    }

    #change-image {
        position: absolute;
        bottom: 8px;
        right: 8px;
        cursor: pointer;
        z-index: 10;
    }
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameImage.vue